import { useDispatch } from 'react-redux';

import { EditorDefaultSidePanelType, setActiveSidePanel } from '../../grid/reduxStore/blockStyleSettingsSlice';
import { SecondaryMenu } from '../component';

export const Uploads = () => {
  const dispatch = useDispatch();

  const handleBackButtonClick = () => {
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.EDITOR_DEFAULT_SIDE_PANEL }));
  };

  return (
    <SecondaryMenu testId="uploads-library-panel" menuTitle="Uploads" backButtonOnClick={handleBackButtonClick}>
      Uploads
    </SecondaryMenu>
  );
};
